// extracted by mini-css-extract-plugin
module.exports = {"root":"Icon_root__11cHj"};